export default __webpack_public_path__ + "static/media/R&B.907f9528.svg";